export function gtagConversion() {
    window.gtag('event', 'conversion', {'send_to': 'AW-798065379/nEueCM2ClsABEOOFxvwC'});
}